import clienteAxios from "../config/axios";

//me trae todoe los activoXcomponentes
export async function getAllProductsXactivo() {
    return clienteAxios.get(`/productsXactivo`);
}
